import { createDraftSafeSelector } from '@reduxjs/toolkit';

import { RootState } from 'App/rootReducer';

import { getSelectedSelfService } from 'modules/selfServices/selectors';
import { PINRestrictedAccess, QRCodeRestrictedAccess } from 'types/RestrictedAccess';

const getUIState = (state: RootState) => state.restrictedAccess;

const getState = createDraftSafeSelector(
  getSelectedSelfService,
  (selfService) => selfService?.kioskRestrictedAccess,
);

export const hasRestrictedAccess = createDraftSafeSelector(getState, Boolean);

export const getGateType = createDraftSafeSelector(
  getState,
  (restrictedAccess) => restrictedAccess?.type,
);

export const getPINCode = createDraftSafeSelector(
  getState,
  (restrictedAccess: PINRestrictedAccess) => restrictedAccess?.pinCode,
);

export const getQRCode = createDraftSafeSelector(
  getState,
  (restrictedAccess: QRCodeRestrictedAccess) => restrictedAccess?.qrCode,
);

export const isRestrictedModalOpen = createDraftSafeSelector(
  getUIState,
  ({ isRestrictedAccessModalOpen }) => isRestrictedAccessModalOpen,
);
